<template>
	<div class="financial-health-calculation body-text-1">
		<ja-button
			v-if="!expanded"
			class="transparent link-question"
			name="expand-financial-health"
			:aria-expanded="expanded.toString()"
			@click.native="toggleAdditionalInfo"
		>
			{{ $t('howIsThisCalculated') }}
		</ja-button>
		<transition name="slide" mode="out-in">
			<div v-show="expanded" class="expanded-modal-section">
				<ja-icon-list-element
					v-for="(item, index) in financialHealthPoints"
					:key="index"
					:title="item.title"
					:info="item.text"
				>
					<svgicon :name="`${item.icon}`"></svgicon>
				</ja-icon-list-element>
				<ja-button
					class="transparent"
					:aria-label="$t('collapseInfo')"
					name="collapse-financial-health"
					:aria-expanded="expanded.toString()"
					@click.native="toggleAdditionalInfo"
				>
					<svgicon class="toggle-cnt" name="arrow-right"></svgicon>
				</ja-button>
			</div>
		</transition>
	</div>
</template>
<script>
import '../icons/arrow-right';
import IconListElement from '../ui/IconListElement';
import Button from '../ui/Button';
export default {
	components: {
		jaIconListElement: IconListElement,
		jaButton: Button
	},
	data() {
		return {
			financialHealthPoints: [
				{
					icon: 'paying',
					title: this.$t('titlePayingDownDebt'),
					text: this.$t('textPayingDownDebt')
				},
				{
					icon: 'general-savings',
					title: this.$t('titleAccumulatingGeneralSavings'),
					text: this.$t('textAccumulatingGeneralSavings')
				},
				{
					icon: 'target',
					title: this.$t('titleWorkingTowardsGoals'),
					text: this.$t('textWorkingTowardsGoals')
				},
				{
					icon: 'calculation',
					title: this.$t('titleStickingYourBudget'),
					text: this.$t('textStickingYourBudget')
				},
				{
					icon: 'score',
					title: this.$t('titleMonitoringYourCreditScore'),
					text: this.$t('textMonitoringYourCreditScore')
				}
			],
			expanded: false
		};
	},
	methods: {
		toggleAdditionalInfo() {
			this.expanded = !this.expanded;
			if (!this.expanded) {
				this.$emit('scrollToTop');
			}
		}
	}
};
</script>
<style lang="scss" scoped>
.financial-health-calculation {
	margin-top: 8px;
	color: $font-blue;

	.link-question {
		color: $link-font-color;

		&:hover {
			cursor: pointer;
			color: $hover-state;
		}
	}

	.expanded-modal-section {
		background-color: $page-bgcolor;
		padding: 32px;

		.toggle-cnt {
			margin-top: 16px;
			fill: $primary-state;
			transform: rotate(-90deg);

			&:hover {
				cursor: pointer;
				fill: $hover-state;
			}
		}

		::v-deep.icon-list-element:not(:last-child) {
			margin-bottom: 27px;
		}

		::v-deep.icon-list-text {
			.title {
				color: #363e52;
				font-family: RobotoMedium;
				font-size: 16px;
				line-height: 24px;
				letter-spacing: 0.5px;
				text-transform: initial;
				line-height: 24px;
				@media (min-width: $breakpoint-mid) {
					font-size: 18px;
					line-height: 27px;
				}
			}
			.info {
				color: #687682;
				font-family: RobotoRegular;
				font-size: 14px;
				line-height: 20px;
				letter-spacing: 0.25px;
				@media (min-width: $breakpoint-mid) {
					font-size: 16px;
					line-height: 24px;
					letter-spacing: 0.5px;
				}
			}
		}
	}

	.slide-enter {
		transform: scaleY(0);
	}

	.slide-enter-active {
		transition: transform 0.6s ease;
		transform-origin: top;
	}

	.slide-leave-to {
		transform: scaleY(0);
	}

	.slide-leave-active {
		transition: transform 0.5s ease;
		transform-origin: top;
	}
}
</style>
